import React, { useEffect } from "react";
import useSeo from "@/hooks/useSeo";
import { smoothScrollToId } from "@/components/kit";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ServicesSection from "@/components/ServicesSection";
import StatsBand from "@/components/StatsBand";
import HowWeWork from "@/components/HowWeWork";
import Cases from "@/components/Cases";
import Testimonials from "@/components/Testimonials";
import AiScan from "@/components/AiScan";
import About from "@/components/About";
import HomeFAQ from "@/components/HomeFAQ";
import Contact from "@/components/Contact";

const HomePage = () => {
  useSeo({
    title: "UPPIT | Online Marketing Bureau – AI, SEO, Webdesign & Content",
    description:
      "UPPIT is het AI-gedreven online marketingbureau voor MKB & ZZP. Meer leads, hogere conversie en betere vindbaarheid in Google én ChatGPT. Start de gratis AI Growth Scan.",
    path: "/",
    ogSlug: "page/home",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      name: "UPPIT",
      description:
        "AI-gedreven online marketingbureau voor MKB & ZZP. AI marketing, SEO, Webdesign, Webflow/WordPress, content en AI-optimalisatie (GEO).",
      url: "https://uppit.nl",
      image: "https://uppit.nl/brand/uppit-logo-creme.png",
      founder: { "@type": "Person", name: "Tim Roosendaal" },
      telephone: "+31641262267",
      email: "info@uppit.nl",
      address: { "@type": "PostalAddress", addressCountry: "NL" },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        reviewCount: "50",
      },
    },
  });

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => smoothScrollToId(id), 150);
    }
  }, []);

  return (
    <main data-testid="home-page" className="bg-ivory">
      <Hero />
      <Marquee />
      <ServicesSection />
      <StatsBand />
      <HowWeWork />
      <Cases />
      <Testimonials />
      <AiScan />
      <About />
      <HomeFAQ />
      <Contact />
    </main>
  );
};

export default HomePage;
